import { z } from "zod";

export const LeaveSchema = z.object({
  type: z.enum(["CL", "SL", "PLL", "MTL", "PTL", "LWP"]),
  from_date: z.string(),
  to_date: z.string(),
  days: z.number().min(1, { message: "Days must be at least 1" }),
  reason: z
    .string()
    .min(3, { message: "Reason must be at least 3 characters" }),
  child_dob: z.string().optional(),
  // documentation: z
  //   .instanceof(File)
  //   .refine(
  //     (file) =>
  //       ["image/png", "image/jpeg", "application/pdf"].includes(file.type),
  //     "File must be a PNG, JPG, or PDF",
  //   )
  //   .refine((file) => file.size <= 10 * 1024 * 1024, "File must be under 10MB")
  //   .optional(),
});

export const EditLeaveSchema = LeaveSchema.partial();
export type EditLeaveFormValues = z.infer<typeof EditLeaveSchema>;